import { useEffect, useRef } from 'react';

import { selectCartContent } from '@/redux/slices/cart.slice';

import { useAppDispatch, useAppSelector } from '@/redux';

import { loadPaymentProvider } from '@/redux/thunks/checkout/loadPaymentProvider';

import '@adyen/adyen-web/styles/adyen.css';

export const AdyenNewCard = ({ t, paymentMode, onlySaveCard = false, handleResponse, onReturn }) => {
  const dispatch = useAppDispatch();
  const adyenComponentRef = useRef(null);
  const paymodeAction = useAppSelector(selectCartContent).paiementMode.action;

  useEffect(() => {
    setTimeout(() => {
      if (adyenComponentRef?.current) {
        dispatch(loadPaymentProvider({ paymentProvider: paymodeAction, binding: adyenComponentRef.current }));
      }
    }, 300);
  }, []);

  return (
    <div ref={adyenComponentRef} data-cs-mask />
  );
};

export default AdyenNewCard;
